import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Card, Row, Col } from 'react-bootstrap';
import OraganicImage from './../../../../Assets/images/organic.svg';
import SocialImage from './../../../../Assets/images/socialmedia.svg';
import FromADsImage from './../../../../Assets/images/fromads.svg';
import OthersImage from './../../../../Assets/images/others.svg';
import './index.scss';

const LeadsDashboard = ({ graphData, leadsourcebase }) => {
  // Convert leadsourcebase to an array if it's an object
  const leadSourceArray = Array.isArray(leadsourcebase) ? leadsourcebase : Object.values(leadsourcebase);
console.log("graphdata",graphData);
  const chartData = {
    labels: graphData.month,
    datasets: [
      {
        label: 'Organic Leads',
        data: graphData.Organic,
        backgroundColor: '#5CA9E8',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
      {
        label: 'Social Media Leads',
        data: graphData.SocialMedia,
        backgroundColor: '#8BD45E',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      },
      {
        label: 'Leads from Ads',
        data: graphData.FromAdds,
        backgroundColor: '#F18226',
        borderColor: 'rgba(255, 206, 86, 1)',
        borderWidth: 1,
      },
      {
        label: 'Other Leads',
        data: graphData.Other,
        backgroundColor: '#F6CE4F',
        borderColor: 'rgba(153, 102, 255, 1)',
        borderWidth: 1,
      },
    ],
  };

  const getLeadCounts = (leadType) => {
    const lead = leadSourceArray.find(item => item.parent === leadType);
    return lead ? lead.child : { "Hot Leads": 0, "Cold Leads": 0, "Warm Leads": 0 };
  }

  const renderLeadCard = (image, leadType,backgroundColor) => {
    const leadCounts = getLeadCounts(leadType);
    const totalLeads = Object.values(leadCounts).reduce((a, b) => a + b, 0);
     return (
      <Card className="mb-3">
        <Card.Body className="d-flex flex-column align-items-center" style={{ padding: 10,borderColor:'none' }}>
          <div style={{ paddingLeft: 20, paddingRight: 20, backgroundColor: backgroundColor,borderRadius:10 }}>
            <img src={image} alt={leadType} style={{ width: '50px', height:"50px" }} />
          </div>
          <div>
            <Card.Text className="d-flex flex-column align-items-center justify-content-center" style={{ margin: 0,color: backgroundColor,fontSize:24 }}>
              {totalLeads}
            </Card.Text>
            <Card.Text style={{ fontSize: 12, margin: 0 }}>{leadType}</Card.Text>
            <Card.Text style={{ fontSize: 10, margin: 0, color: 'grey', lineHeight: 1.5 }}>
              Hot Leads: {leadCounts["Hot Leads"]}
            </Card.Text>
            <Card.Text style={{ fontSize: 10, margin: 0, color: 'grey', lineHeight: 1.5 }}>
              Cold Leads: {leadCounts["Cold Leads"]}
            </Card.Text>
            <Card.Text style={{ fontSize: 10, margin: 0, color: 'grey', lineHeight: 1.5 }}>
              Warm Leads: {leadCounts["Warm Leads"]}
            </Card.Text>
          </div>
        </Card.Body>
      </Card>
    );
  };

  return (
    <div className='cardContainer'>
      <Row>
        <Col md={6}>
          <Bar 
            data={chartData} 
            options={{ maintainAspectRatio: false }} 
            className="chart"
          />
        </Col>
        <Col md={6}>
          <Row>
            <Col md={3}>
              {renderLeadCard(OraganicImage, 'Organic', '#5CA9E8')}
            </Col>
            <Col md={3}>
              {renderLeadCard(SocialImage, 'Social Media', '#8BD45E')}
            </Col>
            <Col md={3}>
              {renderLeadCard(FromADsImage, 'From Adds', '#F18226')}
            </Col>
            <Col md={3}>
              {renderLeadCard(OthersImage, 'Other', '#F6CE4F')}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );


  //   return (
  //     <Card className="mb-3">
  //       <Card.Body className="d-flex flex-column align-items-center" style={{ padding: 10 }}>
  //         <div style={{paddingLeft:20,paddingRight:20,backgroundColor:'' }}><img src={image} alt={leadType} style={{ width: '50px' }} /></div>
          
  //         <div>
  //           <Card.Text className="d-flex flex-column align-items-center justify-content-center" style={{ margin: 0 }}>
  //             {totalLeads}
  //           </Card.Text>
  //           <Card.Text style={{ fontSize: 12, margin: 0 }}>{leadType}</Card.Text>
  //           <Card.Text style={{ fontSize: 10, margin: 0, color: 'grey', lineHeight: 1.5 }}>
  //             Hot Leads: {leadCounts["Hot Leads"]}
  //           </Card.Text>
  //           <Card.Text style={{ fontSize: 10, margin: 0, color: 'grey', lineHeight: 1.5 }}>
  //             Cold Leads: {leadCounts["Cold Leads"]}
  //           </Card.Text>
  //           <Card.Text style={{ fontSize: 10, margin: 0, color: 'grey', lineHeight: 1.5 }}>
  //             Warm Leads: {leadCounts["Warm Leads"]}
  //           </Card.Text>
  //         </div>
  //       </Card.Body>
  //     </Card>
  //   );
  // };

  // return (
  //   <div className='cardContainer'>
  //     <Row>
  //       <Col md={6}>
  //         <Bar 
  //           data={chartData} 
  //           options={{ maintainAspectRatio: false }} 
  //           className="chart"
  //         />
  //       </Col>
  //       <Col md={6}>
  //         <Row>
  //           <Col md={3}>
  //             {renderLeadCard(OraganicImage, 'Organic')}
  //           </Col>
  //           <Col md={3}>
  //             {renderLeadCard(SocialImage, 'Social Media')}
  //           </Col>
  //           <Col md={3}>
  //             {renderLeadCard(FromADsImage, 'From Adds')}
  //           </Col>
  //           <Col md={3}>
  //             {renderLeadCard(OthersImage, 'Other')}
  //           </Col>
  //         </Row>
  //       </Col>
  //     </Row>
  //   </div>
  // );
};

export default LeadsDashboard;
